import {baseUrl,companyId} from './env'
import { Indicator ,Toast} from 'mint-ui';
import {getErrrorMsg} from './language'
import {getStore,removeStore} from './mUtils'
import router from '../router/index'
export default async(url = '', data = {}, type = 'GET') => {
	Indicator.open();
	let token = getStore("token");
	if(token!=null){
		data["token"] =token;
	}
	if(data["companyId"] ==null){
		data["companyId"] =companyId;
	}
	type = type.toUpperCase();
	url = baseUrl + url;
	if (type == 'GET') {
		let dataStr = ''; //数据拼接字符串
		Object.keys(data).forEach(key => {
			dataStr += key + '=' + data[key] + '&';
		})

		if (dataStr !== '') {
			dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
			url = url + '?' + dataStr;
		}
	}
	let requestConfig = {
		method: type,
		mode: "cors"
	}
	
	if (type == 'POST') {
		url+="?token="+token+"&companyId="+companyId;
		Object.defineProperty(requestConfig, 'body', {
			value: JSON.stringify(data)
		});
	}
	try {
		const response = await fetch(url, requestConfig);
		const responseJson = await response.json();
		Indicator.close();
		//console.log("error="+url+"=="+responseJson.errorNo)
		if(responseJson.errorNo=="100005"||responseJson.errorNo=="100004"){
			removeStore("token");
			removeStore("timeOut");
			removeStore("agent");
			Toast({
				message: getErrrorMsg(responseJson.errorNo),
				position: 'bottom'
			});
			router.push('/login');
		}
		return responseJson
	} catch (error) {
		Indicator.close();
		Toast({
			message: getErrrorMsg('-1'),
			position: 'bottom'
		  });
		throw new Error(error);
	}
}




// WEBPACK FOOTER //
// ./src/config/fetch.js